import { Text } from "@chakra-ui/react";
import * as React from "react";
import {
  ActivityFragment,
  ReportFragment,
  ReviewMinimalFragment,
} from "../../../graphql/generated/definitions";
import useTranslations from "../../../hooks/useTranslations";
import { ReviewIcon } from "../../icons";
import Link from "../../utils/Link";
import Activity from "../ActivityPlate";

type ReportFilledActivity = ActivityFragment & {
  recipient: ReviewMinimalFragment;
  trackable: ReportFragment;
};

export function isReportFilledActivity(
  q: ActivityFragment
): q is ReportFilledActivity {
  return q.key === "report.filled";
}

interface ReportFilledActivityProps {
  activity: ReportFilledActivity;
}

export const ReportFilledActivity: React.FC<ReportFilledActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();
  return (
    <Activity
      activity={activity}
      id="reportFilledActivity"
      visual={<ReviewIcon className="w-10 h-10 text-accent-500" />}
    >
      <Text fontSize="sm">
        {t("activity.labels.reportFilled", {
          report: (
            <Link to={`/reports/${activity.trackable.id}`} key="reportLink">
              {t("activity.objects.report")}
            </Link>
          ),
          collaborator: (
            <Link
              to={`/users/${activity.trackable.review.collaborator.slug}`}
              key="userLink"
            >
              {activity.trackable.review.collaborator.name}
            </Link>
          ),
        })}
      </Text>
    </Activity>
  );
};
